import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import { ChurchService } from '@asambleas-services/church/church.service';
import { Church } from '@asambleas-models/church.model';
import { GeneralService } from '@asambleas-services/general/general.service';
import { NotificationsService } from '@asambleas-services/notifications/notifications.service';


/**
 * Muestra los detalles de una iglesia
 * y opciones de eliminación
 */
@Component({
    selector: 'app-ver-iglesia',
    templateUrl: './ver-iglesia.component.html',
    styleUrls: ['./ver-iglesia.component.scss']
})
export class VerIglesiaComponent implements OnChanges, OnInit {

    iglesiasHijasTodas: Church[] = [];
    iglesiasHijas: Church[] = [];

    church: Church;

    //lat: number = 4.708322;
    //lng: number = -74.071796;

    lat: number;
    lng: number;

    cantidadIglesiasHijas: number;
    pageIndex: number = 0;
    pageSize: number = 3;

    displayedColumns = ['name', 'district', 'id'];
    dataSource = new MatTableDataSource();

    //Para metro de control para mostrar elementos de la iglesia en cuestion
    @Input() churchID: any
    // En true muestra las propiedad de eliminar y volver de la interfaz
    @Input() displayProperties: boolean = true

    constructor(
        private _activatedRoute: ActivatedRoute,
        private churchService: ChurchService,
        private generalService: GeneralService,
        private router: Router,
        private _notification: NotificationsService
    ) { }

    ngOnInit() {
        if (this.churchID == undefined) {

            this._activatedRoute.params.subscribe((parameters: Church) => {

                this.displayProperties = false;
                let churchId = parameters.id

                this.church = this.generalService.churches[churchId];
                if (this.church == null) {
                    this.churchService.getChurches().subscribe(
                        (data: Church[]) => {
                            data.forEach(church => {
                                this.generalService.churches[church.id] = church
                                if (churchId == church.id) {
                                    this.church = this.generalService.churches[church.id];

                                    this.setMap();

                                }
                            });
                        },
                        (error) => {
                            console.log('error', error)
                            this.router.navigate(['/admin', 'iglesias']);
                        })
                }
                else {
                    this.setMap();
                }
            })
        }

        this.cargarIglesiasHijas();
    }

    setMap() {
        this.lat = parseFloat(this.church.latitude);
        this.lng = parseFloat(this.church.length);

        //console.log(this.church);
    }

    cargarIglesiasHijas() {
        this.churchService.getChurches()
            .subscribe((data: Church[]) => {
                this.iglesiasHijasTodas = this.churchService.sortIglesiasByNombre(data);
                this.cantidadIglesiasHijas = this.iglesiasHijasTodas.length;

                this.iglesiasHijas = this.iglesiasHijasTodas.slice(0, this.pageSize);
                this.dataSource = new MatTableDataSource(this.iglesiasHijas);
            })
    }

    cambiarPagina($event) {
        this.iglesiasHijas = this.iglesiasHijasTodas.slice($event.pageIndex * this.pageSize, $event.pageIndex * this.pageSize + this.pageSize);
        this.dataSource = new MatTableDataSource(this.iglesiasHijas);
    }

    deletePetition(iglesia:any) {
        this._notification.requestChurchDelete(iglesia)
    }

    ngOnChanges(changes: SimpleChanges) {
        const churchID: SimpleChange = changes.churchID;
        //console.log('prev value: ', churchID.previousValue);
        //console.log('got churchID: ', churchID.currentValue);

        if (churchID.currentValue != null) {
            this.church = this.generalService.churches[Number(this.churchID)];

            //console.log(this.church)

            if (this.church == null) {
                this.churchService.getChurches().subscribe(
                    (data: Church[]) => {
                        data.forEach(church => {
                            this.generalService.churches[church.id] = church
                            if (this.churchID == church.id) {
                                this.church = this.generalService.churches[church.id];
                            }
                        });
                    });
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/ver-iglesia/ver-iglesia.component.ts